import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Select from "react-select";
import { Row, Col, Form } from "react-bootstrap";
import SectionHeader from "components/SectionHeader";
import PortfolioItem from "components/PortfolioItem";
import PageSection from "components/PageSection";
import "./Portfolio.scss";
import Pagination from "components/Pagination/Pagination";
import styled from "styled-components";

const PER_PAGE = 9;
const typeOfPorts = [
  // {
  //   key: "ALL",
  //   value: "All",
  // },
  {
    key: "WEB_APP",
    value: "Web application",
  },
  {
    key: "WEB_MOBILE_APP",
    value: "Web application on mobile",
  },
  {
    key: "MOBILE_APP",
    value: "Mobile application",
  },
  {
    key: "WEB_API",
    value: "Web API / RESTful API",
  },
];

const Portfolio = ({ className, frontmatter }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTypes, setSelectedTypes] = useState(typeOfPorts);

  if (!frontmatter) {
    return null;
  }

  const { anchor, header: rootHeader, subheader: rootSubHeader, portfolios } = frontmatter;
  const portfoliosFilterd = portfolios.filter((item) =>
    selectedTypes.some((x) => x.key === item.type),
  );
  console.log("portfoliosFilterd", portfoliosFilterd);
  const allPage = portfoliosFilterd.length;
  const pages = Math.ceil(allPage / PER_PAGE);
  const startPage = (currentPage - 1) * PER_PAGE;
  const endPage = startPage + 9;

  return (
    <PageSection className={clsx("portfolio-section", className)} id={anchor}>
      <Row>
        <SectionHeader header={rootHeader} subheader={rootSubHeader} />
      </Row>
      <Row>
        <Col>
          <WrapperFilter>
            <Select
              onChange={(values) => setSelectedTypes(values)}
              value={selectedTypes}
              menuPortalTarget={document !== `undefined` ? document.body : null}
              menuPosition="fixed"
              styles={{
                control: (base) => ({
                  ...base,
                  fontFamily: "Roboto Slab",
                }),
                multiValue: (styles, { data }) => {
                  return {
                    ...styles,
                    backgroundColor: "#1a2b55",
                    color: "#fff",
                  };
                },
                multiValueLabel: (styles, { data }) => ({
                  ...styles,
                  color: "#fff",
                }),

                menu: (base) => ({
                  ...base,
                  width: "max-content",
                  minWidth: "100%",
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              // defaultValue={[typeOfPorts[0], typeOfPorts[1], typeOfPorts[2], typeOfPorts[3]]}
              isMulti
              getOptionLabel={(option) => option.value}
              getOptionValue={(option) => option.key}
              options={typeOfPorts}
              className="basic-multi-select"
              classNamePrefix="select"
            />
            {/*  <Filter>
              {typeOfPorts.map((type) => (
                <Form.Check
                  checked={selectedTypes === type.key}
                  onChange={(e) => setSelectedTypes(e.target.value)}
                  key={type.key}
                  value={type.key}
                  label={type.value}
                  name={TYPE_OF_PORT}
                  type={CHECK_TYPE}
                  id={`${type.key}`}
                />
              ))}
            </Filter> */}
          </WrapperFilter>
        </Col>
      </Row>

      <Row>
        <Col>
          <Pagination onChangePage={setCurrentPage} pages={pages} currentPage={currentPage} />
        </Col>
      </Row>
      <Row>
        {portfoliosFilterd
          .slice(startPage, endPage)
          .map(
            ({
              content,
              extraInfo,
              header,
              type,
              imageFileName,
              imageFileNameDetail,
              subheader,
            }) => (
              <PortfolioItem
                key={`${imageFileName}`}
                imageFileName={imageFileName}
                header={header}
                subheader={subheader}
                content={content}
                imageFileNameDetail={imageFileNameDetail}
                extraInfo={
                  <ul>
                    {extraInfo.map((ei) => (
                      <li key={ei}>{ei}</li>
                    ))}
                  </ul>
                }
              />
            ),
          )}
      </Row>
      <Row>
        <Col>
          <Pagination onChangePage={setCurrentPage} pages={pages} currentPage={currentPage} />
        </Col>
      </Row>
    </PageSection>
  );
};

Portfolio.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Portfolio.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Portfolio;

const WrapperFilter = styled.div`
  /* display: flex;
  align-items: center;
  justify-content: center; */
  width: 100%;
  margin-bottom: 10px;
  /* z-index: 10000; */
`;

const Filter = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
